import 'whatwg-fetch';
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import TipForm from '../screens/create-tip';
import {asyncStart, showFeedback, asyncEnd} from '../actions/application';

class CreateTip extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      tip_title: '',
      url: ''
    };
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  dispatch(action){
    this.props.dispatch(action());
  }

  handleSubmit(e) {

    e.preventDefault();
    
    let tipInfo = {};
    Object.assign(tipInfo, this.state);
   

    this.props.dispatch(asyncStart());
    api.createTip(tipInfo)
      .then(() => {
        this.props.dispatch(showFeedback({message: "Your tip has been added successfully."}));
        this.dispatch(asyncEnd);
        hashHistory.push('tips');
      })
      .catch(error => {
        this.dispatch(asyncEnd);
        this.displayFeedBack(error.message);
      })

  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }


  render() {
    return (
      <TipForm
        state={this.state}
        handleChange={this.handleChange.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
      />

    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(CreateTip);


// WEBPACK FOOTER //
// ./src/containers/create-tip.js